import { useUniqueInlineId } from '@inline-svg-unique-id/react'
import React from 'react'
import { SVGIconProps } from '../types'
const SvgArgus = function ({ size = 16, ...props }: SVGIconProps) {
  const _id = useUniqueInlineId()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size}
      height={size}
      viewBox="0 0 200 47"
      fill="currentColor"
      {...props}
    >
      <defs>
        <path
          id={_id}
          d="M62.503 0v7.888l.29 5.646h5.794v-1.672h1.293v22.356l.836.682h1.673v-1.217h-.875v-3.572h.228v-3.725h.076V24.94l1.228.177 13.751-4.523 3.952-3.257h1.637c.842 0 .802.99.15.992l-.075-.004h-.796L76.99 30.91l-.04-.017v2.79H76V34.9h57.523v-5.636l-.017.002v-8.897h-1.17c-.657 0-.686-.628 0-.628h3.82v.712l1.113 8.727 2.338.02.835-7.453h.64l.026-.3h1.213l.041.3h4.6l.306 7 3.22-2.571c-.255-.285.059-.57.344-.257l.257.228-3.273 3.052h3.121v-2.403h8.135V29.2h5.854v5.7h34.37v1.98l.01.075H200l-.645 5.702h-2.947l-1.216 3.65H9.2L0 31.177l2.3-.001V19.788h.285v7.608l.44 3.779h3.95l.001-1.346.15-.008c.474-.01 1.983.068 2.976 1.354h8.736l.001-4.087h1.197v3.986c1.076-.277.874-1.024.874-1.024V18.934h.76l-.777-2.584 7.24-.001v-6.008l-2.128-.913h4.106l-.076.456.608 3.65h28.261l.634-6.045V0zM85.44 21.713 75.074 25.41l.699.1-.001 4.17.223-.184a.43.43 0 0 1 .423-.359l.011.001zm-3.573.926-8.727 2.492 1.863.268zm4.783-1.923-4.783 1.923 3.747-1.07z"
        />
      </defs>
      <use xlinkHref={`#${_id}`} fill="#3E5667" fillRule="evenodd" />
    </svg>
  )
}
export default SvgArgus
